import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../store";
import DepartmentInfo from "../../departmentInfo/DepartmentInfo";

type Props = PropsFromRedux & {};

const DepartmentPreferences = (props: Props) => {
  return (
    <div className="PageWrapper">
      <div className="AdminPreferencesLayout">
        <DepartmentInfo />
      </div>
    </div>
  );
};

type PropsFromRedux = ConnectedProps<typeof connector>;

const mapStateToProps = (state: RootState) => {
  return {};
};

const mapDispatch = {};

const connector = connect(mapStateToProps, mapDispatch);

export default connector(DepartmentPreferences);
